module.exports = __webpack_public_path__ + "static/media/structure_en_big.b71cfb16.png";